var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 18042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5959",
    d: "M1 8.5H15",
    stroke: "#4E5E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5960",
    d: "M8 1.5V15.5",
    stroke: "#4E5E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4618",
    x: 0.75,
    y: 1.25,
    width: 14.5,
    height: 14.5,
    rx: 1.25,
    stroke: "#4E5E91",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBlackIcon);
export default __webpack_public_path__ + "static/media/Grid-black-icon.f97f686e2ab814a48bbc94de1f11ad4b.svg";
export { ForwardRef as ReactComponent };